import { CLASS_IS_ACTIVE } from "../../shared/global/base";
import { getHighlightValues, checkScrollPosition } from "../../shared/elements/NavHighlight";

export default class Tabs {
    static selectors = {
        highlight: '[data-tabs-highlight]',
        wrapper: '[data-jscomponent=Tabs]',
        onLoadSelectedAttr: 'data-tabs-selected'
    };

    readonly module: HTMLElement;
    readonly wrapper: HTMLElement;

    tabBtns: NodeListOf<HTMLButtonElement>;
    tabList: HTMLElement;
    tabPanels: NodeListOf<HTMLDivElement>;
    tabHighlight: HTMLElement;

    resizeTimeout: number;

    constructor(module: HTMLElement) {
        if (module) {
            this.wrapper = module.querySelector(Tabs.selectors.wrapper);
            if (this.wrapper) {
                this.initTabs();

                const selectedTabId = this.wrapper.getAttribute(Tabs.selectors.onLoadSelectedAttr);
                if (selectedTabId) {
                    this.showTab(selectedTabId);
                }
            }
        }
        else {
            throw { name: '', message: 'Moduł powinien być istniejącym elementem DOM, w którym znajduje się komponent Tabs' };
        }
    }

    initTabs() {
        // Required DOM elements
        this.tabBtns = this.wrapper.querySelectorAll('[role=tab]');
        this.tabList = this.wrapper.querySelector('[role=tablist]');
        this.tabPanels = this.wrapper.querySelectorAll('[role=tabpanel]');
        // Optional element for highlighting active btn element
        this.tabHighlight = this.wrapper.querySelector(Tabs.selectors.highlight);

        if (this.tabPanels.length && this.tabPanels.length && this.tabList) {
            this.wrapper.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                if (target.getAttribute('role') === 'tab') {
                    const id = target.getAttribute('aria-controls');
                    if (id) {
                        this.showTab(id);
                    }
                }
            });

            window.addEventListener('resize', this.handleResize.bind(this));
        }
    }

    showTab(id: string) {
        // update buttons view state
        this.tabBtns.forEach(btn => {
            const btnId = btn.getAttribute('aria-controls');
            if (btnId === id) {
                btn.setAttribute('aria-selected', 'true');
                btn.classList.add(CLASS_IS_ACTIVE);
                this.updatePosition(btn);
            }
            else {
                btn.setAttribute('aria-selected', 'false');
                btn.classList.remove(CLASS_IS_ACTIVE);
            }
        });
        // update panels view state
        this.tabPanels.forEach(panel => {
            const tabId = panel.getAttribute('id');
            if (tabId === id) {
                panel.removeAttribute('hidden');
                panel.classList.add(CLASS_IS_ACTIVE);
            }
            else {
                panel.setAttribute('hidden', '');
                panel.classList.remove(CLASS_IS_ACTIVE);
            }
        });

    }

    updatePosition(activeButton: HTMLButtonElement) {
        const values = getHighlightValues(activeButton);
        // update highlight if available
        if (this.tabHighlight) {
            this.tabHighlight.style.transform = values.transform;
        }
        // check scroll and update
        const needScroll = checkScrollPosition(values.width, values.leftCorner, this.tabList);
        if (needScroll !== false) {
            this.tabList.scrollLeft = needScroll;
        }
    }

    handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(() => {
            this.tabBtns.forEach((btn) => {
                if (btn.classList.contains(CLASS_IS_ACTIVE)) {
                    this.updatePosition(btn);
                }
            });
        }, 500);
    }
}
